import React from "react";
import { StyleSheet, Text, View } from "react-native";
import TOKENS from "../styles/tokens";

type Props = {
  payload: unknown;
};

const PayloadPreview: React.FC<Props> = ({ payload }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Simulated Payload</Text>
      <Text selectable style={styles.code}>
        {JSON.stringify(payload, null, 2)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: TOKENS.color.borderStrong,
    borderRadius: TOKENS.radius.lg,
    backgroundColor: TOKENS.color.codeBg,
    padding: TOKENS.spacing.md,
    gap: TOKENS.spacing.xs,
  },
  title: {
    color: TOKENS.color.codeText,
    fontFamily: TOKENS.font.semibold,
    fontSize: TOKENS.fontSize.sm,
  },
  code: {
    color: TOKENS.color.codeText,
    fontFamily: TOKENS.font.mono,
    fontSize: TOKENS.fontSize.xs,
    lineHeight: TOKENS.lineHeight.xs,
  },
});

export default PayloadPreview;
